import { SocialName } from '@/types/common';

export const ICONS_MAP: Record<SocialName, string> = {
	facebook: '/assets/icons/blog/socials/facebook-logo.svg',
	instagram: '/assets/icons/blog/socials/instagram-logo.svg',
	linkedin: '/assets/icons/blog/socials/linkedin-logo.svg',
	x: '/assets/icons/blog/socials/x-logo.svg',
	medium: '/assets/icons/blog/socials/medium-logo.svg',
	dribbble: '/assets/icons/blog/socials/dribbble-logo.svg',
	behance: '/assets/icons/blog/socials/behance-logo.svg'
};
